<script>
import SongDetailContent from "./SongDetailContent.vue";

export default {
  name: "SongViewModal",
  components: { SongDetailContent },
  props: {
    apiUrl: {
      type: String,
      default: "",
    },
    basePath: {
      type: String,
      default: "",
    },
    showActions: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      activeWorkId: "",
    };
  },
  computed: {
    panelConfig: function () {
      var base = String(this.basePath || "");
      var workId = this.activeWorkId;
      return {
        apiUrl: this.apiUrl,
        basePath: base,
        workId: workId,
        editBasicUrl:
          (base === "" ? "" : base) +
          "/main-manage-song.php?page=song_add&mode=edit&section=basic&work_id=" +
          encodeURIComponent(workId),
        editShareUrl:
          (base === "" ? "" : base) +
          "/main-manage-song.php?page=song_add&mode=edit&section=share&work_id=" +
          encodeURIComponent(workId),
      };
    },
    modalTitle: function () {
      return this.activeWorkId ? "ดูข้อมูลเพลง · " + this.activeWorkId : "ดูข้อมูลเพลง";
    },
  },
  methods: {
    open: function (workId) {
      var id = String(workId || "").trim();
      var el = this.$refs.modalEl;
      if (!id) {
        return;
      }
      this.activeWorkId = id;
      this.$nextTick(function () {
        if (!el || !window.bootstrap || !window.bootstrap.Modal) {
          return;
        }
        window.bootstrap.Modal.getOrCreateInstance(el).show();
      });
    },
    close: function () {
      var el = this.$refs.modalEl;
      var inst;
      if (!el || !window.bootstrap || !window.bootstrap.Modal) {
        return;
      }
      inst = window.bootstrap.Modal.getInstance(el);
      if (inst) {
        inst.hide();
      }
    },
    onHidden: function () {
      this.activeWorkId = "";
    },
  },
  mounted: function () {
    var el = this.$refs.modalEl;
    if (el) {
      el.addEventListener("hidden.bs.modal", this.onHidden);
    }
  },
  beforeUnmount: function () {
    var el = this.$refs.modalEl;
    if (el) {
      el.removeEventListener("hidden.bs.modal", this.onHidden);
    }
  },
};
</script>

<template>
  <div ref="modalEl" class="modal fade mct-song-view-modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <i class="ri-music-2-line text-primary me-1 align-middle"></i>{{ modalTitle }}
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <song-detail-content
            v-if="activeWorkId"
            :config="panelConfig"
            :work-id="activeWorkId"
            :show-chrome="false"
            :show-actions="showActions"
          />
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light" data-bs-dismiss="modal">ปิด</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.mct-song-view-modal .modal-dialog {
  max-width: 1140px;
}
.mct-song-view-modal .modal-body {
  background: #f8fafc;
}
.mct-song-view-modal .card {
  box-shadow: none;
}
</style>
